export const config = {
    baseURLApi: process.env.REACT_APP_API_ENDPOINT
}